import Card from '@mui/material/Card';
import { CardHeader, CardContent, Grid, Divider, TextField, Button, Backdrop, CircularProgress, Snackbar, Box, Tooltip, IconButton, Chip } from '@mui/material';
import axios from 'src/utils/axios';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import Alert from 'src/components/Alert';
import { confirmAlert } from 'react-confirm-alert';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import moment from 'moment';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';

function SarisDynamicUnit() {
  const navigate = useNavigate();
  const [dynamicUnitData, setDynamicUnitData] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [uyari, setUyari] = useState(false);
  const [uyariTip, setUyariTip] = React.useState('default');
  const [unitCode, setUnitCode] = React.useState('');
  const [description, setDescription] = React.useState('');
  const [responseMessage, setresponseMessage] = useState({
    ErrorCode: '0',
    ErrorDescription: 'success_message'
  });

  useEffect(() => {
    handleGetSarisDynamicUnit();
  }, []);

  const handleGetSarisDynamicUnit = () => {
    setLoading(true);
    axios
      .get(`GetSarisDynamicUnit`)
      .then(response => {
        setLoading(false);
        var data = response.data;
        setDynamicUnitData(Array.isArray(data) ? data : []);
      })
      .catch(error => {
        setLoading(false);
        return;
      });
  };

  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
  };

  const RouteSarisDynamicUnitDetail = row => {
    navigate(
      `/SarisDynamicUnitDetail/${row.BIRIM_KODU}/${row.KUL_BIRIM_KODU}/${row.ACIKLAMA}`
    );
  };

  const HandleInsertUnit = () => {
    if (unitCode.length > 30) {
      setresponseMessage('Birim Kodu 30 karakterden büyük olamaz !');
      setUyariTip('error');
      setUyari(true);
      return;
    }
    setLoading(true);
    axios
      .get(`SetSarisDynamicNewUnit/${unitCode}/${description}`)
      .then(response => {
        setLoading(false);
        var data = response.data;
        if (data.ErrorCode == '1000') {
          setresponseMessage(data.ErrorDescription);
          setUyariTip('error');
          setUyari(true);
          return;
        } else {
          setresponseMessage(data.ErrorDescription);
          setUyariTip('success');
          setUyari(true);
          handleGetSarisDynamicUnit();
          setUnitCode('');
          setDescription('');
          return;
        }
      })
      .catch(error => {
        setLoading(false);
        return;
      });
  };

  const deleteDynamicUnitCode = (BirimKodu, KulKodu) => {
    confirmAlert({
      message: 'Silmek istediğinizde emin misiniz?',
      buttons: [
        {
          label: 'Evet',
          onClick: () => {
            handleDeleteDynamicUnitCode(BirimKodu, KulKodu);
          }
        },
        {
          label: 'Hayır',
          onClick: () => {
            return;
          }
        }
      ]
    });
  };

  const handleDeleteDynamicUnitCode = (BirimKodu, KulKodu) => {
    setLoading(true);
    axios
      .get(`SetSarisDynamicUnitCodeDelete/${BirimKodu}/${KulKodu}`)
      .then(response => {
        setLoading(false);
        var data = response.data;
        if (data.ErrorCode == '1000') {
          setresponseMessage(data.ErrorDescription);
          setUyariTip('error');
          setUyari(true);
          return;
        } else {
          setresponseMessage(data.ErrorDescription);
          setUyariTip('success');
          setUyari(true);
          handleGetSarisDynamicUnit();
          return;
        }
      })
      .catch(error => {
        setLoading(false);
        return;
      });
  };

  const columns = [
    {
      field: 'KUL_BIRIM_KODU',
      headerName: 'Kod',
      width: 300,
      headerAlign: 'center',
      align: 'center',
      renderCell: params => (
        <Chip
          label={params.row.KUL_BIRIM_KODU}
          size="small"
          variant="outlined"
          clickable
          onClick={() => RouteSarisDynamicUnitDetail(params.row)}
        />
      )
    },
    {
      field: 'ACIKLAMA',
      headerName: 'Açıklama',
      width: 700,
      headerAlign: 'center',
      align: 'center'
    },
    {
      field: 'ADSOYAD',
      headerName: 'Ekleyen Kullancı',
      width: 400,
      headerAlign: 'center',
      align: 'center'
    },
    {
      field: 'TARIH',
      headerName: 'Oluşturulma Tarihi',
      width: 400,
      headerAlign: 'center',
      align: 'center',
      sortComparator: (v1, v2) => {
        const date1 = new Date(v1).getTime();
        const date2 = new Date(v2).getTime();
        return date1 - date2;
      },
      renderCell: params => {
        return moment(params.value).format('DD/MM/YYYY HH:mm:ss');
      }
    },
    {
      field: 'Sil',
      headerName: '',
      headerAlign: 'center',
      align: 'center',
      sortable: false,
      renderCell: cellValues => {
        return (
          <Tooltip title="Sil">
            <IconButton
              size="small"
              onClick={() =>
                deleteDynamicUnitCode(
                  cellValues?.row?.BIRIM_KODU,
                  cellValues?.row?.KUL_KODU
                )
              }
            >
              <DeleteIcon style={{ color: '#FF9800' }} />
            </IconButton>
          </Tooltip>
        );
      },
      width: 80
    }
  ];

  return (
    <>
      <Snackbar
        open={uyari}
        autoHideDuration={5000}
        onClose={uyariKapat}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert
          onClose={uyariKapat}
          variant={uyariTip}
          message={responseMessage}
        ></Alert>
      </Snackbar>
      <Card>
        <Backdrop sx={(theme) => ({ zIndex: theme.zIndex.drawer + 1, color: '#fff' })} open={loading}>
          <CircularProgress color="inherit" />
        </Backdrop>
        <CardHeader title="Dinamik Birim" />
        <Divider />
        <CardContent>
          <Grid container spacing={2}>
            <Grid size={{ xs: 12, md: 6 }}>
              <TextField
                fullWidth
                label="Birim"
                variant="outlined"
                size="small"
                value={unitCode}
                onChange={e => setUnitCode(e.target.value)}
              />
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
              <TextField
                fullWidth
                label="Açıklama"
                variant="outlined"
                size="small"
                value={description}
                onChange={e => setDescription(e.target.value)}
              />
            </Grid>
            <Grid size={12}>
              <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Button
                  variant="contained"
                  color="secondary"
                  startIcon={<AddIcon />}
                  onClick={() => {
                    HandleInsertUnit();
                  }}
                >
                  Ekle
                </Button>
              </Box>
            </Grid>
          </Grid>
          <Box sx={{ mt: 3, height: 600, width: '100%' }}>
            <DataGrid
              sx={{
                '& .MuiDataGrid-columnHeaderTitle': {
                  fontWeight: 700,
                  color: 'text.primary'
                },
                '& .MuiDataGrid-cell': {
                  color: 'text.primary'
                }
              }}
              rows={dynamicUnitData}
              columns={columns}
              getRowId={rows => rows.BIRIM_KODU}
              initialState={{
                pagination: {
                  paginationModel: { page: 0, pageSize: 10 }
                }
              }}
              pageSizeOptions={[10, 25, 50]}
              slots={{ toolbar: GridToolbar }}
              slotProps={{
                toolbar: {
                  showQuickFilter: true,
                  quickFilterProps: { placeholder: 'Ara...' }
                }
              }}
            />
          </Box>
        </CardContent>
      </Card>
    </>
  );
}

export default SarisDynamicUnit;
